module.exports = __webpack_public_path__ + "media/images/icons/fb-b0349f5a76f3681b884493211ad69ad0.svg";